import type { Photo } from "react-photo-album";

const breakpoints = [1080, 640, 384, 256, 128, 96, 64, 48];

function assetLink(asset: string, width: number) {
  return `/images/gal/${asset}`;
}

const photos = [
  { asset: "1-img.webp", width: 3024, height: 4032 },
  { asset: "2-img.webp", width: 3024, height: 4032 },
  { asset: "3-img.webp", width: 3024, height: 4032 },
  { asset: "4-img.webp", width: 1290, height: 2584 },
  { asset: "5-img.webp", width: 4030, height: 2783 },
  { asset: "6-img.webp", width: 1290, height: 1781 },
  { asset: "7-img.webp", width: 3024, height: 4032 },
  { asset: "8-img.webp", width: 3333, height: 2593 },
  { asset: "9-img.webp", width: 3024, height: 4032 },
  { asset: "10-img.webp", width: 3024, height: 4032 },
  { asset: "11-img.webp", width: 3768, height: 2714 },
  { asset: "12-img.webp", width: 3970, height: 2863 },
  { asset: "13-img.webp", width: 3939, height: 2802 },
  { asset: "14-img.webp", width: 4010, height: 2834 },
  { asset: "15-img.webp", width: 2508, height: 3525 },
  { asset: "16-img.webp", width: 1536, height: 2048 },
  { asset: "17-img.webp", width: 1290, height: 911 },
  { asset: "18-img.webp", width: 3024, height: 4032 },
  { asset: "19-img.webp", width: 3024, height: 4032 },
  { asset: "20-img.webp", width: 4032, height: 3024 },
  { asset: "21-img.webp", width: 4032, height: 3024 },
  { asset: "22-img.webp", width: 2048, height: 1536 },
  { asset: "23-img.webp", width: 1525, height: 848 },
].map(
  ({ asset, width, height }) =>
    ({
      src: assetLink(asset, width),
      width,
      height,
      srcSet: breakpoints.map((breakpoint) => ({
        src: assetLink(asset, breakpoint),
        width: breakpoint,
        height: Math.round((height / width) * breakpoint),
      })),
    }) as Photo,
);

export default photos;
